import { Table, Tbody, Td, Th, Thead, Tr, VStack } from "@chakra-ui/react"
import React, { Fragment } from "react"

export type ReadersStatusLogsReportProps = {
	report: Record<string, any[]>
}

export const ReadersStatusLogsReport: React.FC<ReadersStatusLogsReportProps> = ({ report }) => {
	return (
		<VStack w="full" align="stretch" h="full" overflow="auto" spacing={0}>
			<Table size="sm">
				<Thead>
					<Tr>
						<Th>Date</Th>
						<Th>Reader</Th>
						<Th>Type</Th>
						<Th>Connected</Th>
						<Th>Disconnected</Th>
						<Th>Duration</Th>
					</Tr>
				</Thead>
				<Tbody>
					{Object.keys(report).map((key, index) => (
						<Fragment key={key}>
							{report?.[key as any].map((o: any, i: number) => (
								<Tr key={i} bgColor={index % 2 === 0 ? "transparent" : "gray.100"}>
									<Td>{o.date}</Td>
									<Td>{o.reader}</Td>
									<Td>{o.type}</Td>
									<Td>{o.connectedAt}</Td>
									<Td>{o.disconnectedAt}</Td>
									<Td>{o.duration}</Td>
								</Tr>
							))}
						</Fragment>
					))}
				</Tbody>
			</Table>
		</VStack>
	)
}
